import { DealerSliceState, IDealer } from "../types";

export const applyDealerFilters = (state: DealerSliceState): IDealer[] => {
  let list = state.dealersListForFilter;
  if (state.onlyExporters) list = list.filter((d) => d.isExporter);
  if (state.onlySelfWorkers) list = list.filter((d) => d.isSelfWork);
  const q = state.searchQuery.trim().toLowerCase();
  if (q) {
    list = list.filter((d) =>
      Object.values(d).join().toLowerCase().includes(q),
    );
  }
  return list;
};
